// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-dropdown[data-v-b50f0f8c]{border:1px solid #a6a6a6!important}", ""]);
// Exports
module.exports = exports;
